var _templateObject, _templateObject2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';
import { Button } from 'reactstrap';
var HeaderWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  min-width: 100%;\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  padding: 2rem 6rem 2rem 2rem;\n  z-index: 501;\n  // push others right\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-right: auto;\n  }\n"])));
var CloseButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 1.8rem;\n  right: 1.6rem;\n  svg {\n    font-size: 24px;\n  }\n"])));

var PanelHeader = function PanelHeader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClose = _ref.onClose,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "children", "onClose"]);

  return /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    className: clsx('panel__header sticky-top', className)
  }, props), children, onClose && /*#__PURE__*/React.createElement(CloseButton, {
    color: "none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(MdClose, {
    "aria-label": "close panel"
  })));
};

export default PanelHeader;